import script from "./featured-categories.vue?vue&type=script&setup=true&lang=js"
export * from "./featured-categories.vue?vue&type=script&setup=true&lang=js"

import "./featured-categories.vue?vue&type=style&index=0&id=5814c31a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5814c31a"]])

export default __exports__